import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "hiti_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1, size = null) => {
    setItems((prev) => {
      const key = size ? `${product.id}::${size}` : product.id;
      const ex = prev.find((p) => p.key === key);
      if (ex) return prev.map((p) => p.key === key ? { ...p, qty: Math.min(20, p.qty + qty) } : p);
      return [...prev, { key, id: product.id, name: product.name, price: product.price, image: product.image, qty, size }];
    });
  }, []);

  const remove = useCallback((key) => setItems((prev) => prev.filter((p) => p.key !== key && p.id !== key)), []);

  const updateQty = useCallback((key, qty) => {
    if (qty <= 0) return remove(key);
    setItems((prev) => prev.map((p) => (p.key === key || p.id === key) ? { ...p, qty: Math.min(20, qty) } : p));
  }, [remove]);

  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((a, b) => a + b.qty, 0), [items]);
  const total = useMemo(() => items.reduce((a, b) => a + b.price * b.qty, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, updateQty, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
